import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { Link } from 'react-router-dom';

export const Img = styled.img`
  width: 15px;
  height: 15px;
`;
export const FooterBlock = styled.div`
  height: 50px;
`;

export const ProductNameBlock = styled.div`
  width: 70%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0px auto;
`;
const activeClassName = 'active';
export const StyledLink = styled(NavLink).attrs({
    activeClassName: activeClassName,
  })`
    display: block;
    height: 100%;
    padding: 0 10px;
    color: #ffffff;
    line-height: 50px;
    text-decoration: none;
    transition: all 0.3s;
    background: #17ade3;
    &:hover {
      background: #157aac;
      color: #ffffff;
    }
    @media (max-width: 345px) {
      font-size: 14px;
    }
    &.${activeClassName} {
      background: #157aac;
    }
  `;
  export const MainTitle = styled.h1`
  font-size: 20px;
  text-align: center;
  // padding-top: 25px;
`;
export const LinkBlock = styled.div`
  background: #17ade3;
  display: flex;
  justify-content: center;
  margin-top: -50px;
`;

export const Label = styled.label`
min-width: 150px;
  font-size: 16px;
  cursor: pointer;
`;
export const TagsGroup = styled.div`
  display: flex;
  justify-content: center;
  width: 50%;
  margin: 0 auto;
  
`;

export const ButtonGroupBlock = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto 10px;
  margin:20px;
`;
export const ButtonBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const DishCountBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px auto;
`;

export const DishTitleLabel = styled.p`
  margin-right: 10px;
  margin-bottom: 0;
`;

export const NameBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const LoaderBlock = styled.div`
  min-height: 80px;
`;
export const DeleteButton = styled.div`
  width: 25px;
  height: 25px;
  box-sizing: border-box;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  background: #db2828;
  color: #fff;
  border: none;
  border-radius: 5px;
  text-transform: uppercase;
  &:hover {
    background: #d01919;
    border: 1px solid #000542;
  }
  @media (max-width: 992px) {
    width: 20px;
    height: 20px;
  }
`;

export const EditButton = styled(Link)`
  background: #fff;
  width: 25px;
  height: 25px;
  box-sizing: border-box;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: #fff;
  border: 1px solid #000542;
  border-radius: 5px;
  text-transform: uppercase;
  margin-right: 5px;
  &:hover {
    background: #17ade3;
    border: 1px solid #000542;
  }
  @media (max-width: 992px) {
    width: 20px;
    height: 20px;
  }
`;
export const PlayButton=styled.div`
background: green;
width: 25px;
height: 25px;
box-sizing: border-box;
display: flex;
flex-flow: row nowrap;
justify-content: center;
align-items: center;
font-size: 16px;
color: #fff;
border: 1px solid #000542;
border-radius: 5px;
text-transform: uppercase;
margin-right: 5px;
&:hover {
  background: #17ade3;
  border: 1px solid #000542;
}
@media (max-width: 992px) {
  width: 20px;
  height: 20px;
}
`;


// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/CreateTrainingList/TrainingList.js